module.exports = __webpack_public_path__ + "static/media/nextjs.8e784247.png";